// extracted by mini-css-extract-plugin
export default {"onlyDark":"CVCertifications_onlyDark__aj7JU","onlyLight":"CVCertifications_onlyLight__pW6KC","cv-certifications":"CVCertifications_cv-certifications__usfdI"};